export class ArticleEnvironment {
  public static getName = () => 'benzinga-article';
  public static getEnvironment = (env: Record<string, string>) => ({
    analyticsUrl: new URL(env.analyticsUrl ?? 'https://www.benzinga.com'),
    campaignsUrl: new URL(env.campaignsUrl ?? 'https://www.benzinga.com'),
    commentsUrl: new URL(env.commentsUrl ?? 'https://www.benzinga.com/'),
    editorialPreviewKey: env.editorialPreviewKey ?? '',
    editorialToolsUrl: new URL(env.editorialToolsUrl ?? 'https://editorial-tools.benzinga.com/'),
    externalUrl: new URL(env.externalUrl ?? 'https://www.benzinga.com/'),
    internalContentKey: env.internalContentKey ?? '',
    internalContentUrl: new URL(env.internalContentUrl ?? 'https://content-internal.benzinga.com/'),
    key: env.key ?? '',
    recommendedArticlesUrl: new URL(
      env.recommendedArticlesUrl ?? 'https://dot-com-content-recommendation.prod.api.benzinga.dev/',
    ),
    relevantUrl: new URL(env.relevantUrl ?? 'https://www.benzinga.com/'),
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
    wnstnUrl: new URL(env.wnstnUrl ?? 'https://editorial-tools.benzinga.com/api/v2/wnstn/'),
  });
}
